import { get, isArray } from 'lodash';
import { generateUniqueId, getFieldNamefromDataPath, getIDFromResponseOption, isObjectEmpty } from '../../utils/helper';
import { APIS } from '../constants/apis';
import { ANTRAG_HALBJAHR_ART, ANTRAGS_STATUS } from '../constants/constant';
import { PostRecord } from './PostRecord';

// import Schemas
import AntragSchema from '../paths/antrag_FULL_Paths.json';
import KostenPositionSchema from '../paths/kostenposition_FULL_Paths.json';
import SchlusJahrSchema from '../paths/schluljahr_FULL_Paths.json';
const P = AntragSchema.attributes;
const KP_P = KostenPositionSchema.attributes;
const SJ_P = SchlusJahrSchema.attributes;

async function DuplicateAntrag(appId: number, originalAntrag: any, schulJahr: any, MKS_person: number) {
	let kalenderJahrNeueAntrag: number = new Date().getFullYear();
	let halbJahrNeueAntrag = '';
	let schulJahrDetails : any;
	kalenderJahrNeueAntrag = get(schulJahr, SJ_P.Jahr.path)
	
	if (get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.Aktiv.path)) {
		halbJahrNeueAntrag = ANTRAG_HALBJAHR_ART.ersteHalbJahr;
		schulJahrDetails = getHalbJahrDetail(schulJahr, ANTRAG_HALBJAHR_ART.ersteHalbJahr);
		
	} else if (get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.Aktiv.path)) {
		halbJahrNeueAntrag = ANTRAG_HALBJAHR_ART.zweiteHalbJahr;
		schulJahrDetails = getHalbJahrDetail(schulJahr, ANTRAG_HALBJAHR_ART.zweiteHalbJahr);
	}

	let antragData = {
		data: {
			[getFieldNamefromDataPath(P.letzter_ZWV.path)]: appId,
			//
			[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Titel.path)]: getAntragTitel(kalenderJahrNeueAntrag, halbJahrNeueAntrag),
			[getFieldNamefromDataPath(P.Status_Status.path)]: ANTRAGS_STATUS.inBearbeitung,
			[getFieldNamefromDataPath(P.MKS.path)]: getIDFromResponseOption(get(originalAntrag, P.MKS.path)),
			[getFieldNamefromDataPath(P.Ansprechpartner_MKS.path)]: MKS_person,
			// [getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_beantragte_Foerdersumme.path)]: getIDFromResponseOption(
			// 	get(originalAntrag, P.Zusammenfassung_Ueberblick_beantragte_Foerdersumme.path)
			// ),
			[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Halbjahr.path)]: halbJahrNeueAntrag,
			[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Kalenderjahr.path)]: kalenderJahrNeueAntrag,
			[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Von.path)]: new Date(get(schulJahrDetails, 'laufZeitVon')),
			[getFieldNamefromDataPath(P.Zusammenfassung_Ueberblick_Laufzeit_Bis.path)]: new Date(get(schulJahrDetails, 'laufZeitBis')),
		},
	};
	let antragRes = await PostRecord(APIS.Antrag, antragData);

	if (antragRes) {
		await DuplicateKostenPosition(get(antragRes, 'data.id'), get(originalAntrag, P.Antrag_Kostenpositions.path, []), schulJahrDetails);
	}
	return antragRes;
}
export { DuplicateAntrag };

export const getHalbJahrDetail = (schulJahr: any, currentHalbJahr: string) => {
	if (isObjectEmpty(schulJahr)) {
		return null;
	}
	if (currentHalbJahr === ANTRAG_HALBJAHR_ART.ersteHalbJahr) {
		return {
			laufZeitVon: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Laufzeit_Von.path),
			laufZeitBis: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Laufzeit_Bis.path),
			fristVN: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Frist_Fuer_VN.path),
			honorar: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Honorar.path),
			unterrichtswochen: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.Unterrichtswochen.path),
			sachkosten: get(schulJahr, SJ_P.erste_Halbjahr.schema.attributes.erste_Halbjahr_Sachkosten_Pauschal.path),
		};
	}

	if (currentHalbJahr === ANTRAG_HALBJAHR_ART.zweiteHalbJahr) {
		return {
			laufZeitVon: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Laufzeit_Von.path),
			laufZeitBis: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Laufzeit_Bis.path),
			fristVN: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Frist_Fuer_VN.path),
			honorar: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Honorar.path),
			unterrichtswochen: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.Unterrichtswochen.path),
			sachkosten: get(schulJahr, SJ_P.zweite_Halbjahr.schema.attributes.zweite_Halbjahr_Sachkosten_Pauschal.path),
		};
	}
};
export const getAntragTitel = (kalendarJahr: number, halbJahr: string) => {
	if (halbJahr === ANTRAG_HALBJAHR_ART.ersteHalbJahr) {
		return `1. Halbjahr ${kalendarJahr}`;
	} else {
		return `2. Halbjahr ${kalendarJahr}`;
	}
};

async function DuplicateKostenPosition(antragId: number, allKostenPositions: any[], schulJahr: any[]) {
	if (isArray(allKostenPositions)) {
		for (let i = 0; i < allKostenPositions.length; i++) {
			const eachKP = allKostenPositions[i];
			const existingPosId = get(eachKP, KP_P.Allgemein_Position_ID.path);
			const position_id = existingPosId || generateUniqueId();
			let newKPData = {
				[getFieldNamefromDataPath(KP_P.Antrag.path)]: antragId,
				[getFieldNamefromDataPath(KP_P.Allgemein_Foerderprogramm.path)]: getIDFromResponseOption(
					get(eachKP, KP_P.Allgemein_Foerderprogramm.path)
				),
				[getFieldNamefromDataPath(KP_P.Allgemein_Sparte.path)]: getIDFromResponseOption(get(eachKP, KP_P.Allgemein_Sparte.path)),
				[getFieldNamefromDataPath(KP_P.Allgemein_Schule.path)]: getIDFromResponseOption(get(eachKP, KP_P.Allgemein_Schule.path)),
				[getFieldNamefromDataPath(KP_P.Allgemein_Kostenart.path)]: get(eachKP, KP_P.Allgemein_Kostenart.path, null),
				[getFieldNamefromDataPath(KP_P.Allgemein_Lehrkraft_MKS.path)]: get(eachKP, KP_P.Allgemein_Lehrkraft_MKS.path),
				[getFieldNamefromDataPath(KP_P.Allgemein_Bezeichnung.path)]: get(eachKP, KP_P.Allgemein_Bezeichnung.path),
				[getFieldNamefromDataPath(KP_P.Allgemein_Gruppierung_ID.path)]: get(eachKP, KP_P.Allgemein_Gruppierung_ID.path),
				[getFieldNamefromDataPath(KP_P.Allgemein_Position_ID.path)]: position_id,
				// beantragte Summe aus bewilligte nahmen
				[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Klassen.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Klassen.path, 0) || 0,
				[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Ustd_Woche.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Ustd_Woche.path, 0) || 0,
				[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Uwo.path)]: get(schulJahr, "unterrichtswochen",0) || 0,
				[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Anstellung.path)]: get(eachKP, KP_P.Bewilligte_Foerderung_Anstellung.path, null),
				[getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_Honorarsatz.path)]: get(schulJahr, "honorar",0) || 0,
				// [getFieldNamefromDataPath(KP_P.Beantragte_Foerderung_beantragte_Foerderung.path)]: get(
				// 	eachKP,
				// 	KP_P.Bewilligte_Foerderung_bewilligte_Foerderung.path,
				// 	0
				// ),
				// bewilligte Zahlen nullen
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Klassen.path)]: null,
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Ustd_Woche.path)]: null,
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Uwo.path)]: null,
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Anstellung.path)]: null,
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Honorarsatz.path)]: null,
				[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_bewilligte_Foerderung.path)]: null,
				// add Sachkosten only if not null in old KP
				...(get(eachKP, KP_P.Bewilligte_Foerderung_Sachkosten.path, null) !== null && {
					[getFieldNamefromDataPath(KP_P.Bewilligte_Foerderung_Sachkosten.path)]: get(schulJahr, "sachkosten")
				})
			};
			await PostRecord(APIS.Kostenposition, { data: newKPData });
		}
	}
}

// function removeIdsFromArrayObjects(obj: any): any {
// 	if (Array.isArray(obj)) {
// 		// Only remove 'id' from objects within arrays
// 		return obj.map((item: any) => {
// 			if (item && typeof item === 'object') {
// 				const { id, ...rest } = item;
// 				return removeIdsFromArrayObjects(rest);
// 			}
// 			return item;
// 		});
// 	} else if (obj && typeof obj === 'object') {
// 		// Traverse deeper into the object to handle nested arrays
// 		for (const key in obj) {
// 			obj[key] = removeIdsFromArrayObjects(obj[key]);
// 		}
// 	}
// 	return obj;
// }
